export function SiteNotAvailable() {
  return (
    <div className="my-5 flex justify-center text-xl dark:text-gray-0">
      <div> This page is not available yet. Come back later</div>
    </div>
  );
}
